import createIcon from '../../createIcon';

/**
 * @component @name DataArray
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgNFY2SDE4VjE4SDE1VjIwSDIwVjRIMTVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNNCAyMEg5VjE4SDZWNkg5VjRINFYyMFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DataArray = createIcon('DataArray', [
  ['path', { d: 'M15 4V6H18V18H15V20H20V4H15Z', key: '1lf0h4' }],
  ['path', { d: 'M4 20H9V18H6V6H9V4H4V20Z', key: '1ey3f9' }],
]);

export default DataArray;
